module.exports = __webpack_public_path__ + "img/company.93a50ac9.svg";